import { incYenOf, incOf } from '../lib/pricing';
export const residenceHero = {
  title: '高級レジデンス向け 法人研修',
  titleEn: 'FOR LUXURY RESIDENCES',
  lead: '高級レジデンス向け研修は、コンシェルジュとフロントの接遇を執事の基準で統一するプログラムです。',
};

export const residenceTrustBadges = [
  {
    icon: 'ri-building-2-line',
    text: '入居者満足を接遇品質から支える',
  },
  {
    icon: 'ri-map-pin-user-line',
    text: '出張型で貴物件の現場に合わせた訓練',
  },
  {
    icon: 'ri-user-star-line',
    text: '執事養成課程と同一の講師陣',
  },
];

export const residencePainPoints = [
  {
    icon: 'ri-hotel-bed-line',
    text: '入居者の皆様が比べる相手は、近隣の物件ではなく一流ホテルの接遇です。日々の挨拶や取次のひとつひとつが、住み心地と物件の評判を静かに左右します。',
  },
  {
    icon: 'ri-building-line',
    text: '接遇の不満が管理会社への評価や物件の資産価値に直結します。「対応が悪い」という口コミひとつが空室リスクや賃料下落につながりかねません。',
  },
  {
    icon: 'ri-scales-line',
    text: '「どこまでお応えするか」の線引きが担当者ごとに揺れ、一部の入居者に過剰なサービスを提供する一方で、別の方には不足が生じるという不公平が起きています。',
  },
  {
    icon: 'ri-lock-line',
    text: '個人情報・プライバシーへの配慮を仕組みとして徹底したいが、スタッフの意識や経験値に依存しており、統一された基準がないまま運用されています。',
  },
];

export const whyButlerWorks = [
  {
    icon: 'ri-home-heart-line',
    title: '長期の信頼関係を築く技術',
    description:
      '執事は「特定の主に長期で仕える」職業であり、毎日顔を合わせる入居者対応と本質的に同じ構造を持っています。お一人おひとりの好みやご事情を理解し、距離感を保ちながら信頼を積み重ねる技術は、まさにレジデンス接遇が求めるものです。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '距離感と守秘を技術として教えられる',
    description:
      '「親しすぎず、よそよそしすぎない」距離感と、入居者の個人情報やご依頼内容の守秘は、感覚や性格に任せるのではなく、技術として揃えられます。執事教育のメソッドで、担当者が替わっても品質がぶれない基盤をつくります。',
  },
  {
    icon: 'ri-file-list-3-line',
    title: '「型」の言語化でシフト制でも品質を揃える',
    description:
      'お声がけ・取次・案内といった日々の接遇を「型」として言語化し、誰がどのシフトに入っても同じ水準で対応できる仕組みをお渡しします。新人研修の教材としても活用でき、物件ごとの品質差も解消します。',
  },
];

export const recommendedPrograms = [
  {
    title: '半日プラン例',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    modules: 'M1（立ち居振る舞い）＋ M2（VIP・富裕層対応の原則）',
    description:
      '接遇の基本所作と富裕層対応の原則に集中する短期プランです。まずは試行的に導入したい場合や、既存スタッフのブラッシュアップ研修として適しています。',
  },
  {
    title: '1日プラン例',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    modules: 'M1 ＋ M2 ＋ M3（お茶出し・応接実技）＋ M4（想定外対応ロールプレイング）',
    description:
      '所作からVIP対応、ロールプレイングまで、コンシェルジュ・フロント接遇の基盤を1日で網羅する推奨プランです。',
    recommended: true,
  },
  {
    title: '継続プログラム',
    duration: '月1回半日 × 6ヶ月',
    price: incYenOf('ct-advisory-continuous6'),
    modules: '新人受け入れと品質維持の定例研修として推奨',
    description:
      'シフト制の現場に最適な継続型プランです。新人が着任する月に合わせて開始月を設定でき、定期的な研修で品質を維持しながら、全スタッフに行き渡る体制を整えます。',
  },
];

export const residenceScenarios = [
  {
    number: '01',
    title: 'エントランスでのお出迎えと荷物対応',
    description:
      'お声がけの距離とタイミング、入居者か来訪者かの見極め、荷物の受け取りとお渡し、エレベーターまでの誘導まで、エントランスでの一連の対応を実技で確認します。第一印象を決定づける最重要シーンを、執事の基準で整えます。',
    imageSeq: 'residence-scenario-1',
  },
  {
    number: '02',
    title: '取次・代行サービスの所作',
    description:
      '宅配便の受け取りとお届け、クリーニングの預かりとお戻し、タクシー手配とお見送りなど、日常的に発生する取次業務を、正確さと品格を両立する手順に整えます。一つひとつの所作に「信頼できる」という印象を込める技術を習得します。',
    imageSeq: 'residence-scenario-2',
  },
  {
    number: '03',
    title: '難しいご要望への対応',
    description:
      '規約上お応えできないご依頼に対し、お断りと代替案の組み立てをロールプレイングします。「お断りしても印象を悪くしない」技術と、入居者に納得いただける提案力を訓練し、現場で迷わず対応できる判断軸を身につけます。',
    imageSeq: 'residence-scenario-3',
  },
];

export const residenceTargetRoles = [
  'コンシェルジュ',
  'フロントスタッフ',
  'ハウスキーピング窓口',
  '管理員',
  '運営責任者',
];

export const residencePricingPlans = [
  {
    name: '半日プラン',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    note: '2モジュール選択',
  },
  {
    name: '1日プラン',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    note: '4モジュール選択',
    recommended: true,
  },
  {
    name: '2日間パッケージ',
    duration: '12時間（2日間）',
    price: incYenOf('ct-single-2day'),
    note: '全6モジュール受講可',
  },
  {
    name: '継続プログラム',
    duration: '月1回半日 × 6ヶ月',
    price: incYenOf('ct-advisory-continuous6'),
    note: '新人受け入れ・品質維持に',
  },
];

export const residencePricingConditions = {
  dispatch: '出張時の交通費は実費別途',
  capacity: '推奨12名まで。夜勤明け・シフト制への配慮として同内容の複数回開催に対応します',
  payment: 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  cancel: 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',
};

export const residenceFlowSteps = [
  {
    step: '01',
    title: 'お問い合わせ',
    description: 'フォームまたはお電話・メールにてご連絡ください。',
  },
  {
    step: '02',
    title: 'ヒアリング',
    description:
      '物件規模・課題・希望時期などをオンラインまたはお電話で伺います。竣工前・開業前の物件はお引渡し前の集中実施にも対応します。',
  },
  {
    step: '03',
    title: 'プログラム提案・お見積り',
    description:
      'ヒアリング内容をもとに、貴物件に最適な研修プログラムとお見積りをご提案します。',
  },
  {
    step: '04',
    title: '実施',
    description:
      '出張または来校にて研修を実施します。出張型では物件内ラウンジ等の共用施設で訓練します。',
  },
  {
    step: '05',
    title: '実施後レポート',
    description: '研修の総括と改善提案をまとめたレポートをお届けします。',
  },
];

export const propertyTypeOptions = [
  { value: '', label: '選択してください' },
  { value: 'condominium', label: '分譲' },
  { value: 'rental', label: '賃貸' },
  { value: 'membership', label: '会員制' },
  { value: 'multiple', label: '複数物件' },
];

export const residenceFormatOptions = [
  { value: '', label: '選択してください' },
  { value: 'dispatch', label: '出張' },
  { value: 'onsite', label: '来校' },
  { value: 'undecided', label: '未定' },
];

export const residenceFaqs = [
  {
    question: '執事の資格が取れる研修ですか？',
    answer:
      'いいえ。執事の接遇スキルに基づくビジネスマナー研修であり、資格を付与するものではありません。ご希望に応じて受講証（参加証明）を発行します。',
  },
  {
    question: '管理会社経由での発注はできますか？',
    answer:
      'はい。管理会社様・デベロッパー様いずれからのご依頼にも対応します。請求書払い（銀行振込）で承ります。',
  },
  {
    question: '少人数（2〜3名）のチームでも依頼できますか？',
    answer:
      'はい、可能です。料金はプラン単位のため人数が少ない場合も同額ですが、その分一人あたりの実技時間を厚く設計します。',
  },
  {
    question: 'シフト制で全員が同日に集まれません。',
    answer:
      '同一内容を複数回に分けて実施する形式をご提案します。回数と日程はヒアリング時にご相談ください。',
  },
];

export const residenceRelatedPages = [
  {
    title: 'ホテル・旅館',
    description: 'バトラーサービスの型を開業前に整える',
    href: '/corporate/hotel',
  },
  {
    title: '金融・プライベートバンク',
    description: '富裕層営業の信頼を所作から築く',
    href: '/corporate/finance',
  },
  {
    title: '百貨店外商・高級小売',
    description: 'お得意様対応と訪問の作法',
    href: '/corporate/retail',
  },
  {
    title: 'ラグジュアリー営業',
    description: '高級車・宝飾・不動産の商談体験を設計',
    href: '/corporate/luxury-sales',
  },
  {
    title: '医療・美容クリニック',
    description: '自由診療の接遇を院内に定着',
    href: '/corporate/clinic',
  },
  {
    title: '自動車・モビリティ',
    description: 'ブランド体験の接遇を高める',
    href: '/corporate/automotive',
  },
  {
    title: 'ハイヤー・送迎',
    description: '乗降の所作と車内の気配りを磨く',
    href: '/corporate/chauffeur',
  },
];